<picture>
  <source *ngIf="webpSrcset" [srcset]="webpSrcset" type="image/webp" />
  <source [srcset]="defaultSrc" type="image/jpeg" />
  <img
    [width]="width"
    [height]="height"
    [attr.alt]="alt ? alt : ''"
    [class]="class"
    [src]="defaultSrc"
  />
</picture>
<span class="portrait-gradient"></span>
